import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { setTitle } from '../../actions'
import MaterialTable from 'material-table'
// import documentation1 from '../../assets/documentation/documentation1.mp4'
// import documentation2 from '../../assets/documentation/documentation2.mp4'
// import documentation3 from '../../assets/documentation/documentation3.mp4'
// import documentation4 from '../../assets/documentation/documentation4.mp4'
// import documentation5 from '../../assets/documentation/documentation5.mp4'
// import documentation6 from '../../assets/documentation/documentation6.mp4'
// import documentation7 from '../../assets/documentation/documentation7.mp4'
// import documentation8 from '../../assets/documentation/documentation8.mp4'
// import documentation9 from '../../assets/documentation/documentation9.mp4'
// import documentation10 from '../../assets/documentation/documentation10.mp4'
// import documentation11 from '../../assets/documentation/documentation11.mp4'
// import documentation12 from '../../assets/documentation/documentation12.mp4'

const CreateSupplier = props => {
  const { setTitle, themeApp, localization } = props

  useEffect(() => {
    const topbar = {
      title: 'Documentación',
    }
    setTitle(topbar)

    // eslint-disable-next-line
  }, [])

  const data = [
    // {
    //   name: '1. Captura de producción',
    //   description:
    //     'En este video se muestra como capturar la producción',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation1} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '2. Control de aduana',
    //   description:
    //     'En este video se muestra como aprobar o rechazar el control de aduana',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation2} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '3. Control de almacen',
    //   description:
    //     'En este video se muestra como aceptar un producto de aduana en el almacen',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation3} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '4. Crear un embarque (salida de producto terminado)',
    //   description:
    //     'En este video se muestra como crear un nuevo embarque',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation4} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '5. Crear pedido de compra',
    //   description:
    //     'En este video se muestra como crear un nuevo pedido de compra',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation5} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '6 Captura de inventario',
    //   description:
    //     'En este video se muestra como crear una captura de inventario, para comparación de inventario actual con el inventario físico',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation6} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '7. Entrada de materia prima',
    //   description:
    //     'En este video se muestra como crear una entrada de materia prima',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation7} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '8. Salida de materia prima',
    //   description:
    //     'En este video se muestra como crear una salida de materia prima',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation8} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '9. Captura de inventario de materia prima',
    //   description:
    //     'En este video se muestra como crear una captura de inventario de materia prima, para comparación de inventario actual con el inventario físico',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation9} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '10. Entrada de Scrap',
    //   description:
    //     'En este video se muestra como crear una entrada de scrap',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation10} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '11. Salida de Scrap',
    //   description:
    //     'En este video se muestra como crear una salida de scrap',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation11} type="video/mp4" />
    //     </video>
    //   ),
    // },
    // {
    //   name: '12. Captura de inventario de Scrap',
    //   description:
    //     'En este video se muestra como crear una captura de inventario de scrap, para comparación de inventario actual con el inventario físico',
    //   video: (
    //     <video width="100%" height="100%" controls>
    //       <source src={documentation12} type="video/mp4" />
    //     </video>
    //   ),
    // },
  ]

  return (
    <>
      <MaterialTable
        columns={[
          {
            title: 'Nombre',
            field: 'name',
          },
          {
            title: 'Descripción',
            field: 'description',
          },
          {
            title: 'Video',
            field: 'video',
          },
        ]}
        localization={localization}
        data={data}
        title="Lista de tutoriales"
        options={{
          exportAllData: true,
          exportButton: true,
          pageSize: 50,
          pageSizeOptions: [50, 100, 150],
          emptyRowsWhenPaging: false,
          filterCellStyle: {
            backgroundColor: `${
              themeApp.theme === 'light'
                ? themeApp.lightTheme.backgroundButton
                : themeApp.darkTheme.backgroundButton
            }`,
            color: `${
              themeApp.theme === 'light'
                ? themeApp.lightTheme.colorButtonCircle
                : themeApp.darkTheme.colorButtonCircle
            }`,
          },
          headerStyle: {
            backgroundColor: `${
              themeApp.theme === 'light'
                ? themeApp.lightTheme.backgroundButton
                : themeApp.darkTheme.backgroundButton
            }`,
            color: `${
              themeApp.theme === 'light'
                ? themeApp.lightTheme.colorButtonCircle
                : themeApp.darkTheme.colorButtonCircle
            }`,
          },
          rowStyle: {
            backgroundColor: `${
              themeApp.theme === 'light'
                ? themeApp.lightTheme.backgroundButton
                : themeApp.darkTheme.backgroundButton
            }`,
            color: `${
              themeApp.theme === 'light'
                ? themeApp.lightTheme.colorButtonCircle
                : themeApp.darkTheme.colorButtonCircle
            }`,
          },
          actionsCellStyle: {
            color: `${
              themeApp.theme === 'light'
                ? themeApp.lightTheme.colorButtonCircle
                : themeApp.darkTheme.colorButtonCircle
            }`,
          },
          searchFieldStyle: {
            color: `${
              themeApp.theme === 'light'
                ? themeApp.lightTheme.colorButtonCircle
                : themeApp.darkTheme.colorButtonCircle
            }`,
          },
          detailPanelColumnStyle: {
            backgroundColor: `${
              themeApp.theme === 'light'
                ? themeApp.lightTheme.backgroundButton
                : themeApp.darkTheme.backgroundButton
            }`,
            color: `${
              themeApp.theme === 'light'
                ? themeApp.lightTheme.colorButtonCircle
                : themeApp.darkTheme.colorButtonCircle
            }`,
          },
        }}
        style={{
          backgroundColor: `${
            themeApp.theme === 'light'
              ? themeApp.lightTheme.backgroundButton
              : themeApp.darkTheme.backgroundButton
          }`,
          color: `${
            themeApp.theme === 'light'
              ? themeApp.lightTheme.colorButtonCircle
              : themeApp.darkTheme.colorButtonCircle
          }`,
        }}
      />
    </>
  )
}

const mapStateToProps = state => {
  return {
    themeApp: state.reducerApp.themeApp,
    localization: state.reducerApp.localization,
  }
}

const mapDispatchToProps = {
  setTitle,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateSupplier)
